import { useMemo } from "react";
import { useGetIntentContextTypesQuery } from "@/generated/taxonomy";
import { TAXONOMY_CLIENT } from "@/utils/consts";
import { useSelectionLabel } from "./useSelectionLabel";

export const useContextTypeLabel = (selectedIds: string[]): string => {
  const { data } = useGetIntentContextTypesQuery({
    context: { clientName: TAXONOMY_CLIENT },
  });

  const options = useMemo(() => data?.intentContextType?.data ?? [], [data]);

  return useSelectionLabel(selectedIds, options);
};
